<template>
  <div>
    <template v-if="$membershipHasPermissionTo('create automations')">
      <div class="bg-white p-4 rounded border border-gray-400">
        <BaseButton primary @click="setModalCreateVisible(true)"> Add automation </BaseButton>
      </div>
    </template>

    <AutomationList
      :loading="pending"
      :project-uuid="projectId"
      :automations="automations"
      class="mt-4"
      @automation-delete="removeAutomation"
    />

    <template v-if="$membershipHasPermissionTo('create forms')">
      <portal v-if="modalCreateVisible" to="app-dialog">
        <AutomationModalCreate
          :project-uuid="projectId"
          :account-uuid="accountId"
          @closed="modalCreateVisible = false"
        />
      </portal>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import AutomationList from '@/components/ProjectAutomations/AutomationList.vue';
import AutomationModalCreate from '@/components/ProjectAutomations/ModalCreate.vue';

export default {
  components: {
    AutomationList,
    AutomationModalCreate,
  },

  props: {
    accountId: { type: String, required: true },
    projectId: { type: String, required: true },
  },

  data: () => ({
    pending: false,
    modalCreateVisible: false,
  }),

  computed: {
    ...mapState('ui/projectAutomations', {
      automationIds: 'ids',
    }),
    ...mapGetters('ui/projectAutomations', ['automations']),
  },

  created() {
    this.init();
  },

  destroyed() {
    this.setIds([]);
  },

  methods: {
    ...mapActions('ui/projectAutomations', {
      loadAutomations: 'load',
    }),

    ...mapActions('ui/automations', {
      destroyAutomation: 'destroy',
    }),

    ...mapMutations('ui/projectAutomations', ['setIds']),

    async init() {
      const { projectId: projectUuid } = this;

      this.pending = true;

      try {
        await this.loadAutomations({ projectUuid });
      } catch (error) {
        //
      }

      this.pending = false;
    },

    setModalCreateVisible(bool) {
      this.modalCreateVisible = bool;
    },

    async removeAutomation(automationUuid) {
      try {
        await this.destroyAutomation({ automationUuid });

        this.setIds([...this.automationIds.filter((id) => id !== automationUuid)]);
        this.resetAction();
      } catch (error) {
        //
      }
    },
  },
};
</script>
